<template>
	<div class="content">
		<div class="inner_content">
			<div class="header">
				<div class="flex">
					<div class="box flex">
						<div class="title">核销方式：</div>
						<el-select
							v-model="is_cancle"
							placeholder="请选择"
							size="small"
							class="fixedwidth"
						>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					<div class="box flex">
						<div class="title">领取方式：</div>
						<el-select
							v-model="get_type"
							placeholder="请选择"
							size="small"
							class="fixedwidth"
						>
							<el-option
								v-for="item in typeOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					<div class="box flex">
						<div class="title">券类型：</div>
						<el-select
							v-model="type"
							placeholder="请选择"
							size="small"
							class="fixedwidth"
						>
							<el-option
								v-for="item in ticketOption"
								:key="item.value"
								:label="item.name"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>

					<div class="box flex">
						<el-button type="primary" size="small" @click="screen"
							>筛选</el-button
						>
						<el-button size="small" @click="exportList">导出</el-button>
					</div>
				</div>
				<div class="flex">
					<div class="box flex">
						<div class="title">券名称：</div>
						<el-input
							style="width: 180px"
							size="small"
							v-model="title"
						></el-input>
					</div>
					<div class="box flex">
						<div class="title">券时间：</div>
						<el-date-picker
							v-model="dateValue[0]"
							type="date"
							class="date_picker_box"
							placeholder="开始日期"
							value-format="yyyy-MM-dd"
							size="small"
						></el-date-picker>
						<el-time-picker
							placeholder="时间"
							v-model="timeValue[0]"
							class="time_picker_box"
							format="HH:mm:ss"
							value-format="HH:mm:ss"
							size="small"
						></el-time-picker>
						<span style="margin-right:8px">至</span>
						<el-date-picker
							v-model="dateValue[1]"
							type="date"
							class="date_picker_box"
							placeholder="结束日期"
							value-format="yyyy-MM-dd"
							size="small"
						></el-date-picker>
						<el-time-picker
							placeholder="时间"
							v-model="timeValue[1]"
							class="time_picker_box"
							format="HH:mm:ss"
							value-format="HH:mm:ss"
							size="small"
						></el-time-picker>
					</div>
				</div>
				<div class="show">
					<el-card class="box-card" shadow="hover">
						共： <span>{{ total_num }}</span
						>张
					</el-card>
				</div>
			</div>
			<div class="bottom">
				<el-table
					v-loading="loading"
					:data="tableData"
					size="small"
					:header-cell-style="setHeader"
					height="100%"
				>
					<el-table-column prop="title" label="券名称"></el-table-column>
					<el-table-column label="券类型" prop="coupon">
						<!-- <template slot-scope="scope">
              <div v-if="scope.row.coupon_type == 1">满减券</div>
              <div v-if="scope.row.coupon_type == 2">折扣券</div>
              <div v-if="scope.row.coupon_type == 3">代金券</div>
              <div v-if="scope.row.coupon_type == 4">兑换券</div>
              <div v-if="scope.row.coupon_type == 5">储值券</div>
              <div v-if="scope.row.coupon_type == 6">通用券</div>
              <div v-if="scope.row.coupon_type == 7">次数券</div>
            </template> -->
					</el-table-column>
					<el-table-column prop="use_time" label="核销时间"></el-table-column>
					<el-table-column prop="is_cancle" label="核销场景">
						<template slot-scope="scope">
							<div v-if="scope.row.is_cancle == 0">线上</div>
							<div v-if="scope.row.is_cancle == 1">扫码核销</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="" label="消费产品"></el-table-column>
          <el-table-column prop="" label="消费金额"></el-table-column> -->
					<el-table-column prop="info.id" label="会员ID"></el-table-column>
					<el-table-column
						prop="info.real_name"
						label="会员名"
					></el-table-column>
					<el-table-column prop="info.mobile" label="电话"></el-table-column>
					<el-table-column prop="employee.name" label="操作人" width="200">
						<template slot-scope="scope">
							<div v-if="scope.row.is_cancle == 0">
								<el-button type="text">用户本人</el-button>
							</div>
							<div v-if="scope.row.is_cancle == 1">
								<el-button type="text">{{ scope.row.employee.name }}</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="page">
				<el-pagination
					@current-change="handleCurrentChange"
					layout="total, prev, pager, next, jumper"
					:total="total_num"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { couponVerifiy } from "@/api/coupon";
import { exportMethod } from "@/api/vip";

export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {
			loading: false,
			is_used: "1", //使用状态
			is_cancle: "", //核销状态 0 用户使用 1 扫码核销
			get_type: "", //领取方式
			type: "", //券类型
			title: "", //券类型
			page: "1",
			total_num: 0,
			tableData: [],
			formLabelWidth: "120px",
			dialogFormVisible: false,
			options: [
				{
					value: "0",
					label: "用户使用",
				},
				{
					value: "1",
					label: "扫码核销",
				},
			],
			typeOptions: [
				{
					value: "0",
					label: "平台发放",
				},
				{
					value: "1",
					label: "用户领取",
				},
				{
					value: "2",
					label: "赠送",
				},
			],
			ticketOption: [
				{
					name: "满减券",
					value: "1",
				},
				// {
				//   name: "折扣券",
				//   value: "2"
				// },
				{
					name: "代金券",
					value: "3",
				},
				{
					name: "兑换券",
					value: "4",
				},
				// {
				//   name: "储值券",
				//   value: "5"
				// },
				// {
				//   name: "通用券",
				//   value: "6"
				// },
				// {
				//   name: "次数券",
				//   value: "7"
				// }
			],
			value1: "",
			value: "",
			headerStyle: {
				background: "rgba(250,250,250,1)",
				color: "#000000",
			},
			dateValue: [], //消费时间
			timeValue: [],
		};
	},
	mounted() {
		this.getLists();
	},
	methods: {
		// 设置表头颜色
		setHeader({ rowIndex }) {
			if (rowIndex === 0) {
				return this.headerStyle;
			} else {
				return "";
			}
		},
		addSlice() {
			this.$router.push({
				path: `adSign`,
			});
		},
		// 筛选page
		screen() {
			this.page = 1;
			if (
				new Date(this.dateValue[0]).getTime() >
				new Date(this.dateValue[1]).getTime()
			) {
				this.$message("开始时间不能大于结束时间");
			} else {
				this.getLists();
			}
		},
		// 核销记录
		getLists() {
			this.loading = true;
			let data = {
				token: this.token,
				app_id: this.app_id,
				page: this.page,
				is_used: "1",
				is_cancle: this.is_cancle,
				get_type: this.get_type,
				type: this.type,
				title: this.title,
			};
			console.log("数据data", this.dateValue, this.timeValue);
			if (this.dateValue !== null && this.dateValue.length !== 0) {
				if (this.dateValue[0] != null) {
					data.use_time_start = this.timeValue[0]
						? this.dateValue[0] + " " + this.timeValue[0]
						: this.dateValue[0] + " 00:00:00";
					data.use_time_end = this.timeValue[1]
						? this.dateValue[1] + " " + this.timeValue[1]
						: this.dateValue[1] + " 23:59:59";
				}
			}
			couponVerifiy(data).then((res) => {
				this.loading = false;
				console.log("sss", res);
				if (res.code == 200) {
					this.tableData = res.data.result;
					this.tableData.forEach((item) => {
						// if(item.coupon_type)
						switch (item.coupon_type) {
							case 1:
								item.coupon = "满减券";
								break;
							// case 2:
							//   item.coupon = "折扣券";
							//   break;
							case 3:
								item.coupon = "代金券";
								break;
							case 4:
								item.coupon = "兑换券";
								break;
							default:
								item.coupon = "";
								break;
						}
					});
					this.total_num = res.data.total_num;
				} else {
					this.$message.warning(res.msg);
				}
			});
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.page = val;
			this.getLists();
		},
		// 导出
		exportList() {
			if (this.dateValue.length>1) {
				let a = new Date(this.dateValue[0]).getTime();
				let b = new Date(this.dateValue[1]).getTime();
				let c = b - a;
				if (Math.floor(c / 86400000) > 31) {
					this.$message("开始时间与结束时间,间隔不能超过一个月");
				} else {
					var data = {
						token: this.token,
						Api: "coupon/agent.Coupon_Data/index",
						params: [
							{ name: "app_id", value: this.app_id },
							{ name: "is_used", value: "1" },
							{ name: "is_cancle", value: this.is_cancle },
              { name: "get_type", value: this.get_type },
              {name:"use_time_start",value:this.dateValue[0]},
              {name:"use_time_end",value:this.dateValue[1]}
						],
					};
					console.log(data);
					exportMethod(data);
				}
			} else {
				this.$message('请选择时间')
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.content {
	padding: 0 26px 11px 20px;
	min-width: 900px;
	border: node;
	height: 100%;
	// background: rgba(240, 242, 245, 1);
	.inner_content {
		background: #fff;
		padding: 0 24px;
		display: flex;
		flex-direction: column;
		height: 100%;
		.header {
			margin-bottom: 20px;
			.box {
				min-width: 330px;
				.title {
					min-width: 100px;
					text-align: right;
				}
				.fixedwidth {
					width: 180px;
					display: flex;
					justify-content: space-between;
				}
				::v-deep .el-date-editor {
					width: 128px;
				}
			}
		}
		.bottom {
			flex: 1;
		}
		.page {
			height: 50px;
			display: flex;
			align-items: center;
		}
	}
}
// 通用样式
.flex {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 10px 0px;
}
// .el-table td {
// 	// padding: 12px 0;
// }
</style>
